import React from "react";
import "../../css/Wireframe.css";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}
// function getVal(obj, key) {
//   return obj[key];
// }
// function setVal(obj, key, value) {
//   const o = { ...obj };
//   o[key] = value;
//   return o;
// }
function formatNationalId(e, state, field, isZimbabwean = true) {
  let currentValue = String(state[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...state, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: state };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      if (/[A-Z]/.test(e[9])) {
        newValue = e;
        newPlaceholder = e + placeholder1.substring(e.length);
      } else {
        newValue = e;
        newPlaceholder = e + placeholder2.substring(e.length);
      }
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  const newState = { ...state, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class TradersChannelPartner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      tradingName: "",
      registrationNumber: "",
      country: "",
      townCityId: 0,
      primaryContactFirstname: "",
      primaryContactSurname: "",
      primaryContactRole: "",
      primaryContactEmail: "",
      primaryContactCellphone: "",
      primaryContactNationality: "",
      primaryContactIdentification: "",
      primaryContactIdentificationDocument: null,
      primaryContactPassportNumber: "",
      primaryContactPassportDocument: null,
      billingContactFirstname: "",
      billingContactSurname: "",
      billingContactRole: "",
      billingContactEmail: "",
      billingContactCellphone: "",
      billingContactNationality: "",
      billingContactIdentification: "",
      billingContactIdentificationDocument: null,
      billingContactPassportNumber: "",
      billingContactPassportDocument: null,
      physicalAddress: "",
      certificateOfIncorporation: null,
      cr14: null,
      username: "",
      password: "",
      passwordConfirm: "",
      errors: {},
      companyLookupData: {},
      msg: "",
      toastColor: "",
      nationalities: [],
      cities: [],
      idPlaceholderPrimary: ogPlaceholder,
      idPlaceholderBilling: ogPlaceholder,
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePrimaryNationalId = this.handlePrimaryNationalId.bind(this);
    this.handleBillingNationalId = this.handleBillingNationalId.bind(this);
    this.getCompanyLookupData = this.getCompanyLookupData.bind(this);
    this.isZimbabweanPrimary = this.isZimbabweanPrimary.bind(this);
    this.isZimbabweanBilling = this.isZimbabweanBilling.bind(this);
    this.validate = this.validate.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
  }
  componentDidMount() {
    this.getCompanyLookupData();
  }
  getCompanyLookupData() {
    var self = this;
    axios
      .get(API + "/register/getcompanydropdownlists")
      .then(function (response) {
        self.setState({ companyLookupData: response.data || {} });
      })
      .catch(function (error) {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value, type, files } = e.target;
    const newValue = type === "file" ? files[0] : value;
    this.setState({ [name]: newValue }, this.validate);
  }
  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handlePrimaryNationalId(val, field = "primaryContactIdentification") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabweanPrimary()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "primaryContactIdentification"
          ? { idPlaceholderPrimary: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }

  isZimbabweanPrimary() {
    return this.state.primaryContactNationality === "ZW";
  }

  isZimbabweanBilling() {
    return this.state.billingContactNationality === "ZW";
  }

  handleBillingNationalId(val, field = "billingContactIdentification") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabweanBilling()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "billingContactIdentification"
          ? { idPlaceholderBilling: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }

  validate() {
    let s = this.state;
    let errors = {};
    let valid = true;
    if (!s.name || !s.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    }
    if (!s.registrationNumber || !s.registrationNumber.trim()) {
      errors.registrationNumber = "Registration No is required";
      valid = false;
    }
    if (!s.physicalAddress || !s.physicalAddress.trim()) {
      errors.physicalAddress = "Physical Address is required";
      valid = false;
    }
    if (!s.country || !s.country.trim()) {
      errors.country = "Country is required";
      valid = false;
    }
    if (!s.townCityId || s.townCityId === 0) {
      errors.townCityId = "Town/City is required";
      valid = false;
    }
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      errors.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    if (!s.primaryContactFirstname || !s.primaryContactFirstname.trim()) {
      errors.primaryContactFirstname = "Primary Contact Firstname is required";
      valid = false;
    }
    if (!s.primaryContactSurname || !s.primaryContactSurname.trim()) {
      errors.primaryContactSurname = "Primary Contact Surname is required";
      valid = false;
    }
    if (!s.primaryContactRole || !s.primaryContactRole.trim()) {
      errors.primaryContactRole = "Primary Contact Role is required";
      valid = false;
    }
    if (!s.primaryContactEmail || !s.primaryContactEmail.trim()) {
      errors.primaryContactEmail = "Primary Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.primaryContactEmail)) {
      errors.primaryContactEmail = emailError;
      valid = false;
    }
    if (!s.primaryContactCellphone || !s.primaryContactCellphone.trim()) {
      errors.primaryContactCellphone = "Primary Contact Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.primaryContactCellphone)) {
      errors.primaryContactCellphone = phoneError;
      valid = false;
    }
    if (!s.primaryContactNationality || !s.primaryContactNationality.trim()) {
      errors.primaryContactNationality =
        "Primary Contact Nationality is required";
      valid = false;
    }
    if (
      this.isZimbabweanPrimary() &&
      (!s.primaryContactIdentification ||
        !s.primaryContactIdentification.trim())
    ) {
      errors.primaryContactIdentification =
        "Primary Contact National ID is required";
      valid = false;
    } else if (
      this.isZimbabweanPrimary() &&
      !nationalIdRegex.test(s.primaryContactIdentification)
    ) {
      errors.primaryContactIdentification = dynamicNationalIdError(
        s.primaryContactIdentification
      );
      valid = false;
    }

    if (
      !this.isZimbabweanPrimary() &&
      (!s.primaryContactPassportNumber ||
        !s.primaryContactPassportNumber.trim())
    ) {
      errors.primaryContactPassportNumber =
        "Primary Contact Passport Number is required";
      valid = false;
    }
    // Billing Contact validation
    if (!s.billingContactFirstname || !s.billingContactFirstname.trim()) {
      errors.billingContactFirstname = "Billing Contact Firstname is required";
      valid = false;
    }
    if (!s.billingContactSurname || !s.billingContactSurname.trim()) {
      errors.billingContactSurname = "Billing Contact Surname is required";
      valid = false;
    }
    if (!s.billingContactRole || !s.billingContactRole.trim()) {
      errors.billingContactRole = "Billing Contact Role is required";
      valid = false;
    }
    if (!s.billingContactEmail || !s.billingContactEmail.trim()) {
      errors.billingContactEmail = "Billing Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.billingContactEmail)) {
      errors.billingContactEmail = emailError;
      valid = false;
    }
    if (!s.billingContactCellphone || !s.billingContactCellphone.trim()) {
      errors.billingContactCellphone = "Billing Contact Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.billingContactCellphone)) {
      errors.billingContactCellphone = phoneError;
      valid = false;
    }
    if (!s.billingContactNationality || !s.billingContactNationality.trim()) {
      errors.billingContactNationality =
        "Billing Contact Nationality is required";
      valid = false;
    }
    if (
      this.isZimbabweanBilling() &&
      (!s.billingContactIdentification ||
        !s.billingContactIdentification.trim())
    ) {
      errors.billingContactIdentification =
        "Billing Contact National ID is required";
      valid = false;
    } else if (
      this.isZimbabweanBilling() &&
      !nationalIdRegex.test(s.billingContactIdentification)
    ) {
      errors.billingContactIdentification = dynamicNationalIdError(
        s.billingContactIdentification
      );
      valid = false;
    }

    if (
      !this.isZimbabweanBilling() &&
      (!s.billingContactPassportNumber ||
        !s.billingContactPassportNumber.trim())
    ) {
      errors.billingContactPassportNumber =
        "Billing Contact Passport Number is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }
  handleRegister(e) {
    if (e) e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }
    const s = this.state;
    var self = this;
    let request = new FormData();
    request.append("user.username", s.username);
    request.append("user.password", s.password);
    request.append("user.userType", "COMPANY");
    request.append(
      "user.fullName",
      [s.primaryContactFirstname, s.primaryContactSurname].join(" ")
    );
    request.append("user.mobileVerified", "NO");
    request.append("user.activeStatus", "YES");
    request.append("user.emailVerified", "NO");
    request.append("user.isPaidService", "NO");
    request.append("profile.companyName", s.name);
    request.append("profile.tradingName", s.tradingName || "");
    request.append("profile.registrationNumber", s.registrationNumber);
    request.append("profile.townCityId", String(s.townCityId));
    request.append("profile.physicalAddress", s.physicalAddress);
    request.append(
      "profile.primaryContactFirstName",
      s.primaryContactFirstname
    );
    request.append("profile.primaryContactSurname", s.primaryContactSurname);
    request.append(
      "profile.primaryContactIdNumber",
      s.primaryContactIdentification || ""
    );
    request.append(
      "profile.primaryPassportNumber",
      s.primaryContactPassportNumber || ""
    );
    request.append("profile.primaryContactRole", s.primaryContactRole);
    request.append("profile.primaryContactNumber", s.primaryContactCellphone);
    request.append("profile.primaryContactEmail", s.primaryContactEmail);
    request.append(
      "profile.billingContactFirstName",
      s.billingContactFirstname
    );
    request.append("profile.billingContactSurname", s.billingContactSurname);
    request.append(
      "profile.billingContactIdNumber",
      s.billingContactIdentification || ""
    );
    request.append(
      "profile.billingContactPassportNumber",
      s.billingContactPassportNumber || ""
    );
    request.append("profile.billingContactEmail", s.billingContactEmail);
    request.append("profile.billingContactNumber", s.billingContactCellphone);
    request.append("profile.companyType", "CORPORATE");
    if (s.primaryContactIdentificationDocument)
      request.append(
        "primaryContactIdentityDocument",
        s.primaryContactIdentificationDocument
      );
    if (s.primaryContactPassportDocument)
      request.append(
        "primaryContactPassportDocument",
        s.primaryContactPassportDocument
      );
    if (s.billingContactIdentificationDocument)
      request.append(
        "billingContactIdentificationDocument",
        s.billingContactIdentificationDocument
      );
    if (s.billingContactPassportDocument)
      request.append(
        "billingContactPassportDocument",
        s.billingContactPassportDocument
      );
    if (s.certificateOfIncorporation)
      request.append("certificateIncorpFile", s.certificateOfIncorporation);
    if (s.cr14) request.append("cr14File", s.cr14);

    axios
      .post(API + "/register/traderschannelpartner", request)
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1600);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="d-flex flex-column min-vh-100">
        <Banner title="Register as Traders/Channel Partner" align="center" />
        {divMsg}
        <form
          className="d-flex flex-column align-items-center w-100 mt-2 was-validated"
          autoComplete="off"
          onSubmit={this.handleRegister}
        >
          <div className="w-100 card bg-body-tertiary p-3 shadow" style={{ maxWidth: "1200px" }}>
            <h5 className="card-title fw-bold mb-3">Basic Details</h5>
            <div className="row gx-5 gy-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Name</span>
                    <input
                      type="text"
                      name="name"
                      className={`form-control ${s.errors.name ? "z-0" : "z-0"
                        }`}
                      value={s.name}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                  </div>
                  {s.errors.name && (
                    <div className="text-danger small">{s.errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Registration No</span>
                    <input
                      type="text"
                      name="registrationNumber"
                      className={`form-control ${s.errors.registrationNumber ? "z-0" : "z-0"
                        }`}
                      value={s.registrationNumber}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.registrationNumber && (
                    <div className="text-danger small">
                      {s.errors.registrationNumber}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Trading Name</span>
                    <input
                      type="text"
                      name="tradingName"
                      className={`form-control ${s.errors.tradingName ? "z-0" : "z-0"
                        }`}
                      value={s.tradingName}
                      onChange={this.handleChange}
                    />
                  </div>
                  {s.errors.tradingName && (
                    <div className="text-danger small">
                      {s.errors.tradingName}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Primary Contact Section */}
          <div className="card mt-3 shadow bg-body-tertiary" style={{ maxWidth: "1200px", width: "100%" }}>
            <div className="card-body">
              <h5 className="card-title fw-bold mb-3">Primary Contact Details</h5>
              <div className="row gx-3 gy-3">
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Firstname</span>
                      <input
                        type="text"
                        name="primaryContactFirstname"
                        className={`form-control ${s.errors.primaryContactFirstname ? "z-0" : "z-0"
                          }`}
                        value={s.primaryContactFirstname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.primaryContactFirstname && (
                      <div className="text-danger small">
                        {s.errors.primaryContactFirstname}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Surname</span>
                      <input
                        type="text"
                        name="primaryContactSurname"
                        className={`form-control ${s.errors.primaryContactSurname ? "z-0" : "z-0"
                          }`}
                        value={s.primaryContactSurname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.primaryContactSurname && (
                      <div className="text-danger small">
                        {s.errors.primaryContactSurname}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Role</span>
                      <input
                        type="text"
                        name="primaryContactRole"
                        className={`form-control ${s.errors.primaryContactRole ? "z-0" : "z-0"
                          }`}
                        value={s.primaryContactRole}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.primaryContactRole && (
                      <div className="text-danger small">
                        {s.errors.primaryContactRole}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Email</span>
                      <input
                        type="email"
                        name="primaryContactEmail"
                        className={`form-control ${s.errors.primaryContactEmail ? "z-0" : "z-0"
                          }`}
                        value={s.primaryContactEmail}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.primaryContactEmail && (
                      <div className="text-danger small">
                        {s.errors.primaryContactEmail}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Cellphone</span>
                      <input
                        type="text"
                        name="primaryContactCellphone"
                        className={`form-control ${s.errors.primaryContactCellphone ? "z-0" : "z-0"
                          }`}
                        value={s.primaryContactCellphone}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.primaryContactCellphone && (
                      <div className="text-danger small">
                        {s.errors.primaryContactCellphone}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Nationality</span>
                      <Select
                        name="primaryContactNationality"
                        value={(s.companyLookupData.countrys || []).find(
                          ({ value }) => value === s.primaryContactNationality
                        )}
                        onChange={(e) => {
                          this.handlePrimaryNationalId("");
                          this.handlePrimaryNationalId(
                            "",
                            "primaryContactPassportNumber"
                          );
                          this.setState({ idPlaceholderPrimary: ogPlaceholder });
                          this.handleSelect(
                            "primaryContactNationality",
                            e ? e.value : ""
                          );
                        }}
                        className={`form-control ${s.errors.primaryContactNationality ? "" : ""
                          }`}
                        required
                        options={s.companyLookupData.countrys || []}
                      />
                    </div>
                    {s.errors.primaryContactNationality && (
                      <div className="text-danger small">
                        {s.errors.primaryContactNationality}
                      </div>
                    )}
                  </div>
                </div>
                {!!s.primaryContactNationality && this.isZimbabweanPrimary() ? (
                  <>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">National ID</span>
                          <input
                            type="text"
                            name="primaryContactIdentification"
                            className={`form-control ${s.errors.primaryContactIdentification
                              ? "z-0"
                              : ""
                              }`}
                            value={s?.primaryContactIdentification}
                            placeholder={s.idPlaceholderPrimary}
                            onChange={(e) =>
                              this.handlePrimaryNationalId(e.target.value)
                            }
                            required
                          />
                        </div>
                        {s.errors.primaryContactIdentification && (
                          <div className="text-danger small">
                            {s.errors.primaryContactIdentification}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">National ID Document</span>
                          <input
                            name="primaryContactIdentificationDocument"
                            className={`form-control${s.errors.primaryContactIdentificationDocument
                              ? "z-0"
                              : ""
                              }`}
                            type="file"
                            id="primaryContactIdentificationDocument"
                            onChange={this.handleChange}
                            accept=".pdf,image/*"
                          />
                        </div>
                        {s.errors.primaryContactIdentificationDocument && (
                          <div className="text-danger small">
                            {s.errors.primaryContactIdentificationDocument}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : !!s.primaryContactNationality ? (
                  <>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Passport Number</span>
                          <input
                            type="text"
                            name="primaryContactPassportNumber"
                            className={`form-control ${s.errors.primaryContactPassportNumber
                              ? "z-0"
                              : ""
                              }`}
                            value={s.primaryContactPassportNumber}
                            onChange={(e) =>
                              this.handlePrimaryNationalId(
                                e.target.value,
                                "primaryContactPassportNumber"
                              )
                            }
                            required
                          />
                        </div>
                        {s.errors.primaryContactPassportNumber && (
                          <div className="text-danger small">
                            {s.errors.primaryContactPassportNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Passport Document(s)</span>
                          <input
                            name="primaryContactPassportDocument"
                            className={`form-control${s.errors.primaryContactPassportDocument
                              ? "z-0"
                              : ""
                              }`}
                            type="file"
                            id="primaryContactPassportDocument"
                            onChange={this.handleChange}
                            accept=".pdf,image/*"
                          />
                        </div>
                        {s.errors.primaryContactPassportDocument && (
                          <div className="text-danger small">
                            {s.errors.primaryContactPassportDocument}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          {/* Billing Contact Section */}
          <div className="card mt-3 shadow bg-body-tertiary" style={{ maxWidth: "1200px", width: "100%" }}>
            <div className="card-body">
              <h5 className="card-title fw-bold mb-3">Billing Contact Details</h5>
              <div className="row gx-3 gy-3">
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Firstname</span>
                      <input
                        type="text"
                        name="billingContactFirstname"
                        className={`form-control ${s.errors.billingContactFirstname ? "z-0" : "z-0"
                          }`}
                        value={s.billingContactFirstname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.billingContactFirstname && (
                      <div className="text-danger small">
                        {s.errors.billingContactFirstname}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Surname</span>
                      <input
                        type="text"
                        name="billingContactSurname"
                        className={`form-control ${s.errors.billingContactSurname ? "z-0" : "z-0"
                          }`}
                        value={s.billingContactSurname}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.billingContactSurname && (
                      <div className="text-danger small">
                        {s.errors.billingContactSurname}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Role</span>
                      <input
                        type="text"
                        name="billingContactRole"
                        className={`form-control ${s.errors.billingContactRole ? "z-0" : "z-0"
                          }`}
                        value={s.billingContactRole}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.billingContactRole && (
                      <div className="text-danger small">
                        {s.errors.billingContactRole}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Email</span>
                      <input
                        type="email"
                        name="billingContactEmail"
                        className={`form-control ${s.errors.billingContactEmail ? "z-0" : "z-0"
                          }`}
                        value={s.billingContactEmail}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.billingContactEmail && (
                      <div className="text-danger small">
                        {s.errors.billingContactEmail}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Cellphone</span>
                      <input
                        type="text"
                        name="billingContactCellphone"
                        className={`form-control ${s.errors.billingContactCellphone ? "z-0" : "z-0"
                          }`}
                        value={s.billingContactCellphone}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.billingContactCellphone && (
                      <div className="text-danger small">
                        {s.errors.billingContactCellphone}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text">Nationality</span>
                      <Select
                        name="billingContactNationality"
                        value={(s.companyLookupData.countrys || []).find(
                          ({ value }) => value === s.billingContactNationality
                        )}
                        onChange={(e) => {
                          this.handleBillingNationalId("");
                          this.handleBillingNationalId(
                            "",
                            "billingContactPassportNumber"
                          );
                          this.setState({ idPlaceholderBilling: ogPlaceholder });
                          this.handleSelect(
                            "billingContactNationality",
                            e ? e.value : ""
                          );
                        }}
                        className={`form-control ${s.errors.billingContactNationality ? "" : ""
                          }`}
                        required
                        options={s.companyLookupData.countrys || []}
                      />
                    </div>
                    {s.errors.billingContactNationality && (
                      <div className="text-danger small">
                        {s.errors.billingContactNationality}
                      </div>
                    )}
                  </div>
                </div>
                {!!s.billingContactNationality && this.isZimbabweanBilling() ? (
                  <>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">National ID</span>
                          <input
                            type="text"
                            name="billingContactIdentification"
                            className={`form-control ${s.errors.billingContactIdentification
                              ? "z-0"
                              : ""
                              }`}
                            value={s.billingContactIdentification}
                            placeholder={s.idPlaceholderBilling}
                            onChange={(e) =>
                              this.handleBillingNationalId(e.target.value)
                            }
                            required
                          />
                        </div>
                        {s.errors.billingContactIdentification && (
                          <div className="text-danger small">
                            {s.errors.billingContactIdentification}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">National ID Document</span>
                          <input
                            name="billingContactIdentificationDocument"
                            className={`form-control ${s.errors.billingContactIdentificationDocument
                              ? "z-0"
                              : ""
                              }`}
                            type="file"
                            id="billingContactIdentificationDocument"
                            onChange={this.handleChange}
                            accept=".pdf,image/*"
                          />
                        </div>
                        {s.errors.billingContactIdentificationDocument && (
                          <div className="text-danger small">
                            {s.errors.billingContactIdentificationDocument}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : !!s.billingContactNationality ? (
                  <>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Passport Number</span>
                          <input
                            type="text"
                            name="billingContactPassportNumber"
                            className={`form-control ${s.errors.billingContactPassportNumber
                              ? "z-0"
                              : ""
                              }`}
                            value={s.billingContactPassportNumber}
                            onChange={(e) =>
                              this.handleBillingNationalId(
                                e.target.value,
                                "billingContactPassportNumber"
                              )
                            }
                            required
                          />
                        </div>
                        {s.errors.billingContactPassportNumber && (
                          <div className="text-danger small">
                            {s.errors.billingContactPassportNumber}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Passport Document(s)</span>
                          <input
                            name="billingContactPassportDocument"
                            className={`form-control ${s.errors.billingContactPassportDocument
                              ? "z-0"
                              : ""
                              }`}
                            type="file"
                            id="billingContactPassportDocument"
                            onChange={this.handleChange}
                            accept=".pdf,image/*"
                          />
                        </div>
                        {s.errors.billingContactPassportDocument && (
                          <div className="text-danger small">
                            {s.errors.billingContactPassportDocument}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <div className="w-100 mt-3 card bg-body-tertiary p-3 shadow" style={{ maxWidth: "1200px" }}>
            <h5 className="card-title fw-bold mb-3">Other Details</h5>
            <div className="row gx-5 gy-3">
              <div className="col-12">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Physical Address</span>
                    <input
                      type="text"
                      name="physicalAddress"
                      className={`form-control ${s.errors.physicalAddress ? "z-0" : "z-0"
                        }`}
                      value={s.physicalAddress}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.physicalAddress && (
                    <div className="text-danger small">
                      {s.errors.physicalAddress}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Country</span>
                    <Select
                      value={(s.companyLookupData.countrys || []).find(
                        ({ value }) => value === s.country
                      )}
                      onChange={(e) =>
                        this.handleSelect("country", e ? e.value : "")
                      }
                      className={`form-control ${s.errors.country ? "" : ""
                        }`}
                      required
                      options={s.companyLookupData.countrys || []}
                    />
                  </div>
                  {s.errors.country && (
                    <div className="text-danger small">{s.errors.country}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Town/City</span>
                    <Select
                      name="townCityId"
                      value={(s.companyLookupData.townCitys || []).filter(
                        ({ value }) => value === s.townCityId
                      )}
                      onChange={(e) =>
                        this.handleSelect("townCityId", e ? e.value : "")
                      }
                      className={`form-control ${s.errors.townCityId ? "" : ""
                        }`}
                      required
                      options={s.companyLookupData.townCitys || []}
                    />
                  </div>
                  {s.errors.townCityId && (
                    <div className="text-danger small">
                      {s.errors.townCityId}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Certificate of Incorporation</span>
                    <input
                      name="ownershipFile"
                      className={`form-control ${s.errors.ownershipFile ? "z-0" : "z-0"
                        }`}
                      type="file"
                      id="certOfIncorp"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                  </div>
                  {s.errors.certificateOfIncorporation && (
                    <div className="text-danger small">
                      {s.errors.certificateOfIncorporation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">CR14</span>
                    <input
                      name="ownershipFile"
                      className={`form-control${s.errors.ownershipFile ? "z-0" : "z-0"
                        }`}
                      type="file"
                      id="cr14"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                  </div>
                  {s.errors.cr14 && (
                    <div className="text-danger small">{s.errors.cr14}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Username</span>
                    <input
                      type="text"
                      name="username"
                      className={`form-control ${s.errors.username ? "z-0" : "z-0"
                        }`}
                      value={s.username}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.username && (
                    <div className="text-danger small">{s.errors.username}</div>
                  )}
                </div>
              </div>
              <div></div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Password</span>
                    <input
                      name="password"
                      type="password"
                      className={`form-control ${s.errors.password ? "z-0" : "z-0"
                        }`}
                      value={s.password}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.password && (
                    <div className="text-danger small">{s.errors.password}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text">Password Confirm</span>
                    <input
                      name="passwordConfirm"
                      type="password"
                      className={`form-control ${s.errors.passwordConfirm ? "z-0" : "z-0"
                        }`}
                      value={s.passwordConfirm}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.passwordConfirm && (
                    <div className="text-danger small">
                      {s.errors.passwordConfirm}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-4 mt-4 mb-4">
            {s.valid && (
              <button type="submit" className="btn btn-primary">
                <i className="bi bi-check-circle me-2"></i>Register
              </button>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => window.history.back()}
            >
              <i className="bi bi-x-circle me-2"></i>Cancel
            </button>
          </div>
        </form>

      </div>
    );
  }
}
